'use client';

import BasicButton from 'core/BasicButton';
import { useState } from 'react';
import { listTechnical } from 'shared/sections/TechnicalExpertise/ExpertisePanel/constants';
import ExpertisePanelContent from 'shared/sections/TechnicalExpertise/ExpertisePanel/ExpertisePanelContent';

import cn from './style.module.sass';

const getData = () => {
    return listTechnical;
};

type TabsTitle = 'frontend' | 'backend' | 'devops' | 'qa';

export type Product = {
    name: string;
    logo: string;
};

export type PanelContent = {
    title: string;
    products: Product[];
    content?: string;
};

type CurrentData = {
    [key in TabsTitle]: PanelContent[];
};

type ExpertisePanelProps = {
    tabs: string[];
};

export default function ExpertisePanel({ tabs }: ExpertisePanelProps) {
    const [currentPanel, setCurrentPanel] = useState<string>(tabs[0] as string);
    const currentData: CurrentData = getData();
    const currentList: PanelContent[] = currentData[currentPanel as keyof typeof currentData];
    const activeClass = cn['expertisePanel__tabs-item--active'];

    const handleChangeActive = (name: string) => {
        setCurrentPanel(name);
    };

    return (
        <div className={cn['expertisePanel']}>
            <div className={cn['expertisePanel__tabs']}>
                {tabs.map(el => (
                    <BasicButton
                        key={el}
                        className={`${cn['expertisePanel__tabs-item']} ${
                            currentPanel === el ? activeClass : ''
                        }`}
                        onClick={() => handleChangeActive(el)}
                    >
                        {el}
                    </BasicButton>
                ))}
            </div>
            <ExpertisePanelContent currentList={currentList} />
        </div>
    );
}
